import { z, isoZ } from 'my-zod'

export const attachmentModel = z.object({
  id: z.number(),
  shortId: z.string(),
  description: z.string().nullable(),
  unsignedS3Url: z.string().setLabel('File Name'),
  fileType: z.string().setLabel('File Type'),
  uploadedByUserId: z.number().setLabel('Attached By'),
  createdDate: isoZ.instant().setLabel('Date Added'),
  deletedDate: isoZ.instant().nullable()
})

export type attachmentModel = z.infer<typeof attachmentModel>
